











































































































































































































































































































import OrderExpressAndConsignee from '@/views/order/components/order_express_and_consignee.vue'
import { apiOrderWriteOffOrderDetail } from '@/api'
import { BookComponents } from '../components'
import { BookOrderComponents } from './components'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { JointComponents } from '../../joint/components'
import { navigateTo } from '@/router'
import { requiredDeep, showPicker, Track } from '@/utils'
import { wait } from 'vtils'

export default defineClassComponent(
  {
    components: {
      ...BookComponents,
      ...BookOrderComponents,
      ...JointComponents,
      OrderExpressAndConsignee,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '订单详情',
        }))
      }

      query = useQuery<{
        orderNo: string
        fromParent: boolean
      }>()

      apiData = useApi(
        () =>
          apiOrderWriteOffOrderDetail({
            orderNo: this.query.orderNo,
          })
            .then(requiredDeep)
            .then(res => {
              const groupedSaleId: string[] = []
              res.codeList.forEach(code => {
                if (!code.saleId) {
                  // @ts-ignore
                  code.codes = [code.code]
                } else if (!groupedSaleId.includes(code.saleId)) {
                  groupedSaleId.push(code.saleId)
                  // @ts-ignore
                  code.codes = res.codeList
                    .filter(item => item.saleId === code.saleId)
                    .map(item => item.code)
                }
              })
              // @ts-ignore
              res.groupedCodeList = res.codeList.filter(
                code =>
                  // @ts-ignore
                  !!code.codes,
              )
              return res
            }),
        {
          refreshOnActivated: true,
        },
      )

      pageData = computed(() => this.apiData.data)

      is待支付 = computed(() => this.pageData.value.status === 0)

      isJoint = computed(() => this.pageData.value.orderClassify === 5)

      handleSubOrderClick = (orderNo: string) => {
        navigateTo('BookOrderDetail', {
          orderNo,
          fromParent: true,
        })
      }

      handleGoodsClick = () => {
        navigateTo(
          this.isJoint.value ? 'JointGoodsIndex' : 'BookGoodsIndex',
          {
            goodsId: this.pageData.value.commodityId,
          },
        )
      }

      handleRefresh = async () => {
        await wait(1500)
        this.apiData.refresh()
      }

      handleRefundClick = () => {
        navigateTo('BookRefundRequest', {
          orderNo: this.query.orderNo,
        })
      }

      handleRefundResultClick = (refundId: string) => {
        navigateTo('BookRefundResult', {
          refundId: refundId,
        })
      }

      handleInvoiceClick = () => {
        if (this.isJoint.value) {
          showPicker({
            title: '请选择开票订单',
            data: this.pageData.value.comboData[0].groupDetails.map(
              (item, index) => ({
                label: item.serviceName,
                value: index,
              }),
            ),
            initialValue: 0,
            onConfirm: index => {
              navigateTo(
                (this.pageData.value.comboData[0].groupDetails[index] as any)
                  .invoiceStatus === 2
                  ? 'InvoiceDetail'
                  : 'InvoiceRequest',
                {
                  orderNo: (
                    this.pageData.value.comboData[0].groupDetails[
                      index
                    ] as any
                  ).orderNo,
                },
              )
            },
          })
        } else {
          navigateTo(
            this.pageData.value.invoiceStatus === 2
              ? 'InvoiceDetail'
              : 'InvoiceRequest',
            {
              orderNo: this.pageData.value.orderNo,
            },
          )
        }
      }
    },
)
